import React from "react";

/**
 * Catches render-time errors anywhere in the tree and shows a recovery
 * screen instead of a blank page. Reloading recovers the common cases
 * (a bad code split after a deploy, a transient state error); the mailto
 * link carries the error message so reports arrive with something to
 * work from.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("Render error caught by ErrorBoundary:", error, info);
  }

  render() {
    if (!this.state.error) {
      return this.props.children;
    }

    if (this.props.compactFallback) {
      return <div className="loanHelpFailure" role="alert"><p>{this.props.compactFallback}</p>{this.props.fallbackLinks && this.props.fallbackLinks.map(([href, label]) => <a key={href} href={href}>{label}</a>)}</div>;
    }

    const message =
      (this.state.error && this.state.error.message) || "Unknown error";
    const mailBody = encodeURIComponent(
      `Page: ${window.location.href}\nError: ${message}`,
    );

    return (
      <div className="maximumWidth">
        <div className="panel inputPanel" role="alert">
          <h1 style={{ fontSize: "1.4rem" }}>
            <i className="bi bi-exclamation-triangle"></i> Something went wrong
          </h1>
          <p>
            The page hit an error and could not continue. Your inputs are not
            sent anywhere, so nothing has been lost beyond this page view.
          </p>
          <p>
            Reloading usually fixes it. If it keeps happening, an email with
            the error details below helps us find the cause.
          </p>
            <div className="resultsButtonFlex">
            <button
              type="button"
              className="btn btn-primary"
              onClick={() => window.location.reload()}
            >
              Reload the page
            </button>
            <a
              className="btn btn-outline-secondary"
              href={`mailto:contact@studentcalc.co.uk?subject=${encodeURIComponent(
                "The UK Student Loan Calculator error report",
              )}&body=${mailBody}`}
            >
              Email the error details
            </a>
            <a className="btn btn-outline-secondary" href="/">
              Back to the calculator
            </a>
            </div>
            {this.props.fallbackLinks && <p className="errorFallbackLinks">{this.props.fallbackLinks.map(([href, label]) => <a key={href} href={href}>{label}</a>)}</p>}
          <p style={{ marginTop: "12px", fontSize: "0.8rem", color: "#64748b" }}>
            {message}
          </p>
        </div>
      </div>
    );
  }
}

export default ErrorBoundary;
